import { useState } from 'react'
import { BottomSheet } from './BottomSheet.jsx'

/**
 * Custom select: button + BottomSheet picker.
 *
 * Props:
 *   value      — currently selected option value
 *   onChange   — (value) => void
 *   options    — [{ value, label, icon?, sub? }, ...]
 *   placeholder— shown when no value
 *   label      — heading shown at the top of the sheet
 *   disabled
 */
export function Select({ value, onChange, options, placeholder, label, disabled }) {
  const [open, setOpen] = useState(false)
  const selected = options.find(o => o.value === value)

  return (
    <>
      <button
        type="button"
        className={`custom-select${disabled ? ' disabled' : ''}`}
        onClick={() => !disabled && setOpen(true)}
        disabled={disabled}
      >
        <span className="custom-select-value">
          {selected?.icon && <span className="custom-select-icon">{selected.icon}</span>}
          {selected ? selected.label : <span className="custom-select-placeholder">{placeholder ?? ''}</span>}
        </span>
        <svg className="custom-select-chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      <BottomSheet open={open} onClose={() => setOpen(false)} className="bsheet-select">
        <div className="select-sheet">
          {label && <header className="select-sheet-head">{label}</header>}
          <ul className="select-options">
            {options.map(o => (
              <li
                key={o.value}
                className={`select-option${o.value === value ? ' active' : ''}`}
                onClick={() => { onChange(o.value); setOpen(false) }}
              >
                {o.icon && <span className="select-option-icon">{o.icon}</span>}
                <span className="select-option-label">
                  {o.label}
                  {o.sub && <span className="select-option-sub">{o.sub}</span>}
                </span>
                {o.value === value && (
                  <svg className="select-option-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </li>
            ))}
          </ul>
        </div>
      </BottomSheet>
    </>
  )
}
